import { Component, createRef } from 'preact'
import IframePreview from './iframe'
import {
    widgetV2Url,
    TENANTS
} from '../constants'
import { __ } from '../../locales'

const randomId = () =>
    Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 8);

class WidgetPreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            containerId: randomId(),
        }
        this.codeRef = createRef()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.inputs.tenant !== this.props.inputs.tenant) {
            this.props.keywords = []
        }
    }

    getQuery = () => {
        const { layoutType, inputs, extraParams, widgetName } = this.props;
        const options = { ...inputs, layoutType, widgetName, tenantId: inputs?.tenant, containerId: this.state.containerId };
        // AU regulation: an empty link on the AU tenant is the "Disabled" option; signal it so the
        // widget renderer skips its profile-page fallback and renders no link at all.
        options.disableLink = inputs.tenant === TENANTS.AU.name && !inputs.linkUrl
        const params = [
            'containerId',
            'widgetName',
            'tenantId',
            'linkUrl',
            'disableLink',
            'language',
            'profileType',
            'theme',
            'keyword',
            ...extraParams,
        ];

        const reqParams = this.props.requiredParams || []
        if (!reqParams.length || reqParams.every(p => Boolean(options[p]))) {
            return params.filter(f => !!options[f]).map(p => `${p}=${encodeURIComponent(options[p])}`).join('&').replace(/#/g, '')
        }
        return null
    };

    getTemplate = () => {
        const query = this.getQuery()
        if (query === null) {
            return null
        }
        const { widgetName, inputs } = this.props
        const { containerId } = this.state
        const tenantId = inputs?.tenant
        const iframeSrc = `${widgetV2Url}/${widgetName}?${query}`
        const scriptSrc = `${widgetV2Url}/doctify-widget-autoresize-plugin.js?tenantId=${tenantId}&widgetName=${widgetName}&containerId=${containerId}`
        return `<iframe id="${containerId}" class="doctify-widget" src="${iframeSrc}" width="100%" frameborder="0" scrolling="no" name="${widgetName}">Browser doesn't support frames</iframe><script type="text/javascript" src="${scriptSrc}"></script>`
    };

    render(
        { title, description, bestFor, selectedProfiles, children, keywords, fetchKeywords, fixedWidth, fixedHeight, defaultHeight },
        { showScript, scriptLoaded, scriptTemplate }) {
        return (
            <div className="container">
                <h2 className={'mb-3'}>{title}</h2>
                {description && <h6 className={'mb-2'}>{description}</h6>}
                {bestFor && (
                    <h6>
                        <div style={{ gap: '12px' }} className={'d-flex align-items-center mb-2'}>{__('global.best_displayed_on')}: {bestFor?.map?.((bf) => (
                            <div style={{ gap: '6px' }} className={'d-flex align-items-center'}>
                                <div className={'check-icon'} /> <b>{bf}</b>
                            </div>
                        ))}</div>
                    </h6>
                )}
                {children}

                <IframePreview
                    id={this.state.containerId}
                    widgetName={this.props.widgetName}
                    template={this.getTemplate()}
                    badgeTitle={this.props.badgeTitle}
                    badgeColor={this.props.badgeColor}
                    badgeFontColor={this.props.badgeFontColor}
                    shouldLoad={selectedProfiles.length}
                    fixedWidth={fixedWidth}
                    fixedHeight={fixedHeight}
                    defaultHeight={defaultHeight}
                />
            </div>
        )
    }
}

export default WidgetPreview
